import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Alerts, GetSettings } from "../../../helpers";
import parse from 'html-react-parser';
const ShippingRateForm = ({shipping_zone, handleCloseRateZone, getShippingZone}) => {
  const [showConditional, setShowConditional] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [shippingRateLabels, setShippingRateLabels] = useState([]);

  const validationSchema = Yup.object({
    rateType: Yup.string().required("Required"),
    shipping_rate_label_id: Yup.string().required("Required"),
    price: Yup.number().min(0, "Price cannot be negative").required("Required"),
    conditionalType: Yup.string().when([], {
      is: () => showConditional,
      then: (schema) => schema.required("Required"),
    }),
    minWeight: Yup.number().when("conditionalType", {
      is: "weight",
      then: (schema) => schema.required("Required").min(0, "Must be >= 0"),
    }),
    maxWeight: Yup.number().when("conditionalType", {
      is: "weight",
      then: (schema) => schema.required("Required"),
    }),
    minPrice: Yup.number().when("conditionalType", {
      is: "price",
      then: (schema) => schema.required("Required").min(0, "Must be >= 0"),
    }),
    maxPrice: Yup.number().when("conditionalType", {
      is: "price",
      then: (schema) => schema.required("Required"),
    }),
  });

  const getShippingRateLabels = async () => {
    const resp = await GetSettings.getShippingRateLabels();
    if (resp && resp.status) {
      setShippingRateLabels(resp.shipping_rate_labels);
      setLoading(false);
    }
  };

  useEffect(() => {
    getShippingRateLabels();
  }, []);


  const handleAddShippingZoneRate = async (values, {setSubmitting, resetForm}) =>{
      const resp = await GetSettings.createShippingZoneRate(values);
     if (resp && resp.status) {
        Alerts.alertMessage(resp.message, 'top-center', 'success');
        setSubmitting(false);
        resetForm();
        handleCloseRateZone();
        getShippingZone();
    }else{
        Alerts.alertMessage('Something went wrong!', 'top-center', 'error');
        setSubmitting(false);
    }
  }
  return (
    <>
      {isLoading ? (
        <div className="loader">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      ) : (
        <Formik
          enableReinitialize={true}
          initialValues={{
            rateType: "flat_rate",
            shipping_zone_id:shipping_zone.id,
            shipping_rate_label_id: shippingRateLabels.length > 0 ? shippingRateLabels[0].id : '',
            shippingRateLabel: shippingRateLabels.length > 0 ? shippingRateLabels[0].preview_label : '',
            price: 0,
            currency: "GBP",
            conditionalType: "",
            minWeight: 0.00,
            maxWeight: 0.00,
            minPrice: 0.00,
            maxPrice: 0.00
          }}
          validationSchema={validationSchema}
          onSubmit={handleAddShippingZoneRate}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting
          }) => (
            <form onSubmit={handleSubmit}>
              {/* Rate Type */}
              <div className="mb-3">
                <label>Rate type</label>
                <select
                  name="rateType"
                  value={values.rateType}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="form-control"
                >
                  <option value="flat_rate">Use flat rate</option>
                  {/* <option value="calculated_rate">Use calculated rate</option> */}
                </select>
                {touched.rateType && errors.rateType && (
                  <div className="text-red-500 text-sm">{errors.rateType}</div>
                )}
              </div>

              {/* Shipping Rate */}
              <div className="mb-3">
                <label>Shipping rate</label>
                <select
                  name="shipping_rate_label_id"
                  value={values.shipping_rate_label_id}
                  onChange={(e)=>{
                    handleChange(e);
                    let fLabel = shippingRateLabels.find(el=>el.id === parseInt(e.target.value))
                    if(fLabel){
                       setFieldValue('shippingRateLabel',fLabel.preview_label)
                    }
                  }}
                  onBlur={handleBlur}
                  className="form-control"
                >
                  {shippingRateLabels.length > 0 &&
                    shippingRateLabels.map((labelItem) => (
                      <option value={labelItem.id} key={labelItem.id}>
                        {labelItem.name}
                      </option>
                    ))}
                </select>
                {touched.shippingRate && errors.shippingRate && (
                  <div className="text-red-500 text-sm">
                    {errors.shippingRate}
                  </div>
                )}
              </div>

              {/* Price */}
              <div className="row">
                <div className="mb-3 col-md-6 price-input">
                  <label>Price</label>
                  <input
                    type="number"
                    name="price"
                    value={values.price}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="form-control hid-icon"
                    placeholder="0.00"
                  />
                  {values.price === 0 || values.price === '' && <span>Free</span>}
                </div>
                <div className="mb-3 col-md-6">
                  <label>&nbsp;</label>
                  <select
                    name="currency"
                    value={values.currency}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="GBP">British Pound (GBP £)</option>
                    {/* <option value="USD">US Dollar ($)</option>
                    <option value="EUR">Euro (€)</option> */}
                  </select>
                  {touched.price && errors.price && (
                    <div className="text-red-500 text-sm">{errors.price}</div>
                  )}
                </div>
              </div>

              {/* Conditional Pricing Toggle */}
              <div className={showConditional ? "mb-1" : "mb-3"}>
                <label
                  className="block font-medium text-primary"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowConditional(!showConditional)
                    setFieldValue('minWeight', '')
                    setFieldValue('maxWeight', '')
                    setFieldValue('minPrice', '')
                    setFieldValue('maxPrice', '')
                     setFieldValue('conditionalType', '')
                    
                  }
                  }
                >
                  {showConditional
                    ? "Remove Conditional Pricing"
                    : "Add Conditional Pricing"}
                </label>
              </div>

              {/* Conditional Section */}
              {showConditional && (
                <>
                  {/* Radio Buttons */}
                  <div className="mb-3">
                    <label className="d-flex align-items-center gap-2">
                      <input
                        type="radio"
                        name="conditionalType"
                        value="weight"
                        checked={values.conditionalType === "weight"}
                        onChange={(e) => {
                          handleChange(e);
                            setFieldValue('minWeight', '')
                            setFieldValue('maxWeight', '')
                            setFieldValue('minPrice', '')
                            setFieldValue('maxPrice', '')
                        }}
                      />
                      Based on item weight
                    </label>
                    <label className="d-flex align-items-center gap-2">
                      <input
                        type="radio"
                        name="conditionalType"
                        value="price"
                        checked={values.conditionalType === "price"}
                        onChange={(e) => {
                          handleChange(e);
                            setFieldValue('minWeight', '')
                            setFieldValue('maxWeight', '')
                            setFieldValue('minPrice', '')
                            setFieldValue('maxPrice', '')
                        }}
                      />
                      Based on order price

                    </label>
                    {touched.conditionalType && errors.conditionalType && (
                      <div className="text-red-500 text-sm">
                        {errors.conditionalType}
                      </div>
                    )}
                  </div>

                  {/* Min & Max Weight */}
                  {values.conditionalType === "weight" && (
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label>Minimum weight (kg)</label>
                        <input
                          type="number"
                          name="minWeight"
                          value={values.minWeight}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="form-control"
                        />
                        {touched.minWeight && errors.minWeight && (
                          <div className="text-red-500 text-sm">
                            {errors.minWeight}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label>Maximum weight (kg)</label>
                        <input
                          type="number"
                          name="maxWeight"
                          value={values.maxWeight}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="form-control"
                        />
                        {touched.maxWeight && errors.maxWeight && (
                          <div className="text-red-500 text-sm">
                            {errors.maxWeight}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Min & Max Price */}
                  {values.conditionalType === "price" && (
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label>Minimum price (£)</label>
                        <input
                          type="number"
                          name="minPrice"
                          value={values.minPrice}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="form-control"
                        />
                        {touched.minPrice && errors.minPrice && (
                          <div className="text-red-500 text-sm">
                            {errors.minPrice}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label>Maximum price (£)</label>
                        <input
                          type="number"
                          name="maxPrice"
                          value={values.maxPrice}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className="form-control"
                        />
                        {touched.maxPrice && errors.maxPrice && (
                          <div className="text-red-500 text-sm">
                            {errors.maxPrice}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Preview */}
              <div className=" preview-box">
                <p>
                  <strong>Checkout preview</strong>
                </p>
                <div className="preview-box-inner border rounded bg-gray-100">
                  <div>
                    <div className="check-icon">
                        <img src="/images/radio-icon.png" alt=""/>
                    </div>
                   <div>{parse(values.shippingRateLabel)}</div> 
                    {values.conditionalType === "price" ? `Price Range - (£${values.minPrice} - £${values.maxPrice})` : null}
                    {values.conditionalType === "weight" ? `Weight Range - (${values.minWeight}kg - ${values.maxWeight}kg)` : null}
                  </div>
                  <div className="price-tag">{values.price > 0 ? `£ ${values.price}` : 'Free'}</div>
                </div>

              </div>

              {/* Submit */}
              <div className="d-flex align-items-center justify-content-center gap-2 mt-3">
                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                 {isSubmitting ? 'Please wait..' : 'Done'}
                </button>
              </div>
            </form>
          )}
        </Formik>
      )}
    </>
  );
};

export default ShippingRateForm;
